import axios from "axios";

export const savePersonalDocument = (data, callback) => {
  let method, url;
  
  // Ahora siempre esperamos JSON (incluso archivos vienen en Base64)
  const documentId = data.personal_document?.id;
  
  if (documentId) {
    method = "patch";
    url = `/api/personal_documents/${documentId}`;
  } else {
    method = "post";
    url = "/api/personal_documents";
  }

  // Configurar headers según el tipo de datos
  const headers = {
    "X-CSRF-TOKEN": window.Hupe8.token
  };
  
  // Si es JSON, agregar Content-Type
  if (!isFormData) {
    headers["Content-Type"] = "application/json";
  }

  axios({
    method: method,
    url: url,
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token,
      "Content-Type": "application/json"
    }
  })
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

export const deletePersonalDocument = (id, callback) => {
  var promise = axios({
    method: "delete",
    url: `/api/personal_documents/${id}`,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
